<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow"
				 :dialog-class="''"
				 :ok-title="'Search'"
				 ok-variant="success"
				 :cancel-title="'Clear'"
				 @ok="getStockOpnamePlans"
				 @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
					<app-input-textbox id="fieldset-name" label-cols-sm="4" label-cols-lg="3" label="Stock Opname Name" label-for="filter-name" size="sm" :model.sync="filter.name" />
					<app-input-datetimepicker-range id="fieldset-start-stock-opname-period" label-cols-sm="4" label-cols-lg="3" label="Stock Opname Period" size="sm" :modelFrom.sync="filter.startStockOpnamePeriodFrom" :modelTo.sync="filter.startStockOpnamePeriodTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
					</b-col>
					<b-col cols="12" lg="6">
					<!-- <app-input-datetimepicker-range id="fieldset-finish-stock-opname-period" label-cols-sm="4" label-cols-lg="3" label="Finish Stock Opname Period" size="sm" :modelFrom.sync="filter.finishStockOpnamePeriodFrom" :modelTo.sync="filter.finishStockOpnamePeriodTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button /> -->
					<app-input-combobox-autocomplete :options="stockOpnameStatuss" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Stock Opname Status" id="filter-" size="sm" :model.sync="filter.stockOpnameStatusId" @input="getStockOpnameStatuss" @focus="getStockOpnameStatuss" />
					</b-col>
					<b-col cols="12" lg="6">

						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getStockOpnamePlans"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Stock Opname Plan</span>
				</b-col>
				<b-col>
					<span class="float-right">
						<!-- <b-dropdown v-if="true" text="Action" class="m-md-2 btn-action-more" size="sm">
							<b-dropdown-item v-if="(userRole != null ? userRole.allowDownload : false)" href="files/stockopnameplan/StockOpnamePlan.xlsx"><b-icon-wallet class="mr-1"></b-icon-wallet> Download Template</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowUpdate : false)" @click="showPopupUploadData"><b-icon-upload class="mr-1"></b-icon-upload> Upload Data</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowPrint : false)" @click="printData"><b-icon-printer class="mr-1"></b-icon-printer> Export To Pdf</b-dropdown-item>
						</b-dropdown> -->
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" to="/stockopnameplan/create" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

					</span>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" to="/stockopnameplan/create" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<!-- <b-button v-if="true" class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download</b-button> -->
					
					<b-overlay v-if="isShowDeleteButton"
							   :show="isDeleteBusy"
							   rounded
							   opacity="0.6"
							   spinner-small
							   spinner-variant="primary"
							   class="d-inline-block">
						<click-confirm>
							<b-button class="btn-action" @click="deleteMultipleData" size="sm"><b-icon-trash class="mr-1"></b-icon-trash> Delete</b-button>
						</click-confirm>
					</b-overlay>
					
					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table sticky-header="565px" :stacked="isStacked" id="table-list-stockopnameplan" :class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="head-light" :bordered="true" :no-local-sorting="true" :items="stockOpnamePlans" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="stockOpnamePlans.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template v-slot:head(front-action)>
						<b-button @click="isShowFilter = !isShowFilter" size="sm" class="btn-filter float-right"><b-icon-funnel /></b-button>
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
				<b-th stacked-heading="Stock Opname Name" class="table-filter">
					<b-form-input id="input-name-table" @input="getStockOpnamePlansWithoutLoading" v-model="filter.name" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Stock Opname Period" class="table-filter">
					<app-input-datetimepicker-range id="fieldset-start-stock-opname-period" label-cols-sm="4" label-cols-lg="3" :nolabel="true" label="Start Stock Opname Period" size="sm" :modelFrom.sync="filter.startStockOpnamePeriodFrom" :modelTo.sync="filter.startStockOpnamePeriodTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button  @change="getStockOpnamePlansWithoutLoading" />
				</b-th>
				<!-- <b-th stacked-heading="Finish Stock Opname Period" class="table-filter">
					<app-input-datetimepicker-range id="fieldset-finish-stock-opname-period" label-cols-sm="4" label-cols-lg="3" :nolabel="true" label="Finish Stock Opname Period" size="sm" :modelFrom.sync="filter.finishStockOpnamePeriodFrom" :modelTo.sync="filter.finishStockOpnamePeriodTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button  @change="getStockOpnamePlansWithoutLoading" />
				</b-th> -->
				<b-th stacked-heading="Stock Opname Status" class="table-filter">
					<v-select append-to-body label="name" :options="stockOpnameStatuss" :value="filter.stockOpnameStatusId" :reduce="item => item.id" v-model="filter.stockOpnameStatusId" :filterable="true" @input="getStockOpnamePlansWithoutLoading" @search="getStockOpnameStatuss"></v-select>
				</b-th>
				<b-th></b-th>

					</template>
					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
					</template>

					<template v-slot:cell(name)="row">

                <a @click="() => ( $router.push({ name: 'stockopnameplandetail', params : { id: row.item.id } }))" class="a-link-detail">
							{{ row.item.name != null && row.item.name != "" ?
								(typeof row.item.productCode == 'string') ?
									row.item.name.slice(0, 30) + (row.item.name.length > 30 ? "..." : "" ) : row.item.name : "" }}
						</a>
            
					</template>

			<template v-slot:cell(startStockOpnamePeriod)="row">
				{{ row.item.startStockOpnamePeriod | moment("DD-MMM-YYYY") }}
			</template>
			<!-- <template v-slot:cell(finishStockOpnamePeriod)="row">
				{{ row.item.finishStockOpnamePeriod | moment("DD-MMM-YYYY HH:mm") }}
			</template> -->
			<template v-slot:cell(stockOpnameStatus)="row">
				{{ row.item.stockOpnameStatus != null ? row.item.stockOpnameStatus.name : "" }}
			</template>

			<template v-slot:cell(actionStart)="row">
				<div style="display: flex; justify-content: center; align-items: center;">
					<b-button v-if="row.item.stockOpnameStatusId == stockOpnameStatusNotActive.id" class="btn-create btn-fill-success" @click="startAction(row.item)" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Start</b-button>
					<b-button v-if="row.item.stockOpnameStatus.code == 'IN_PROGRESS'" class="btn-create btn-fill-success" @click="finishAction(row.item)" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Finish</b-button>
					<b-overlay :show="isPdfBusy"
						v-if="row.item.stockOpnameStatus.code == 'CLOSED'"
						rounded
						opacity="0.6"
						spinner-small
						spinner-variant="primary"
						class="float-right ">
						<b-button v-if="row.item.stockOpnameStatus.code == 'CLOSED'" size="sm" class="float-right btn-default" @click="printExcel(row.item.id)">
							Print STO Result
						</b-button>
					</b-overlay>
				</div>
			</template>

					<template v-slot:cell(front-action)="row">
						<div class="d-flex justify-content-center ml-2" v-if="isShowDeleteButton">
							<b-form-checkbox v-if="row.item.stockOpnameStatusId == stockOpnameStatusNotActive.id" :id="'input-is-checked-' + (row.index + 1)" @change="toggleSelect(Number(row.item.id))" :checked="checkAllData.includes(Number(row.item.id))"></b-form-checkbox>
						</div>
					</template>
					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
						<app-input-datetimepicker id="fieldset-finish-stock-opname-period" label-cols-lg="12"  label="Finish Stock Opname Period" size="sm" :model.sync="row.item.finishStockOpnamePeriod"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  :isEditable="false" :isUpdatable="true" />
						<app-input-combobox optionsLabel="name" label-cols-sm="12" :model="row.item.stockOpnameStatusId" label="Stock Opname Status" :selected="row.item.stockOpnameStatus != null ? row.item.stockOpnameStatus.name : ''" :isEditable="false" :isUpdatable="true" />

						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="paging-container">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
									v-model="currentPage"
									:total-rows="(stockOpnamePlansPaging != null ? stockOpnamePlansPaging.dataCount : 0)"
									:per-page="(stockOpnamePlansPaging != null ? stockOpnamePlansPaging.pageSize : 0)"
									aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
		
        <PopupBeritaAcara :openPopup="isShowPopupBeritaAcara"
            @resetMethod="resetPopupBeritaAcara"
            :stockOpnamePlanId="selectedStockOpnamePlanId" />

		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';

    

    ::v-deep #table-list-stockopnameplan.b-table.b-table-stacked > tbody > tr > td.th-front-action::before {
        background-image: url(/img/box-checklist.png);
        background-size: 40px 40px;
        display: block;
        width: 40px;
        height: 40px;
        content: "";
        margin-bottom: 10px;
    }

	::v-deep #table-list-stockopnameplan.b-table>thead>tr>th {
		background: #e28b29;
	}

    ::v-deep #table-list-stockopnameplan.b-table.b-table-stacked > tbody > tr > td.th-front-action > div {
        display: flex;
    }
</style>
<script>
import StockOpnamePlan from '@/models/StockOpnamePlan/StockOpnamePlan';
import StockOpnamePlanList from '@/models/StockOpnamePlan/StockOpnamePlanList';
import StockOpnamePlanFilter from '@/filters/StockOpnamePlan/StockOpnamePlanFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextarea from '@/components/AppInputTextarea';
import StockOpnameStatusFilter from '@/filters/StockOpnameStatus/StockOpnameStatusFilter';
import StockOpnameStatus from '@/models/StockOpnameStatus/StockOpnameStatus';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';
import PopupBeritaAcara from './PopupBeritaAcara';

export default {
	components : {
		StockOpnamePlan, 
		StockOpnamePlanList, 
		StockOpnamePlanFilter, 
		AppInputTextbox,
		AppInputDatetimepicker,
		AppInputDatetimepickerRange,
		AppInputTextarea,
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		PopupDownload,
		PopupPDF,
		Upload,
		PopupDataEditNotification,
		PopupBeritaAcara
	},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"front-action": { "class" : "th-front-action", "label" : ""}},
				{"no" : {"class" : "th-number d-stack-none"}},
				{"name": {}, "class" : "th-name first-child", "label" : "Stock Opname Name", key: 'name', sortable: true}, 
				{"startStockOpnamePeriod": {}, "class" : "th-start-stock-opname-period", "label" : "Stock Opname Period", key: 'startStockOpnamePeriod', sortable: true}, 
				// {"finishStockOpnamePeriod": {}, "class" : "th-finish-stock-opname-period last-child", "label" : "Finish Stock Opname Period", key: 'finishStockOpnamePeriod', sortable: true}, 
				{"stockOpnameStatus": {}, "class" : "th-stock-opname-status d-stack-none", "label" : "Status", key: 'stockOpnameStatus', sortable: true}, 
				{"actionStart": {"class" : "th-stock-opname-action d-stack-none", "label" : "Action" }}, 

				{"actions": {"class" : "th-actions d-stack-show", "label" : ""}}
			],
			yesNoCombo: [
				{ id : 'TRUE', name : 'True', selected:true },
				{ id : 'FALSE', name : 'False' },
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			stockOpnamePlans: [],
			stockOpnamePlansPaging: {},
			stockOpnameStatuss : [],

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			isScannerMode: false,
			stockOpnameStatusNotActive: {},
			isShowPopupBeritaAcara: false,
			selectedStockOpnamePlanId:'',
			isPdfBusy: false,
			
		}
	},	methods : {
		printExcel: async function(id) {
			this.isPdfBusy = true;

			try {
				
				let data = parseInt(id);
				if(!isNaN(data)) {
					console.log(data);
					const response = await this.$http.get(`StockOpnamePlan/printExcelStoResultBatch/${data}`);
					if(response && response.data) {
						this.excelFile = process.env.VUE_APP_API_URL + 'DownloadFiles/' + response.data;

						console.log(this.excelFile);
						// Create a temporary anchor element and trigger a click to download the file
						const link = document.createElement('a');
						link.href = this.excelFile;
						//link.setAttribute('download', 'stockopnameresult.xlsx'); // You can set the file name here
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
					}
				}
			} catch(error) {
				this.isPdfBusy = false;
			} finally {
				this.isPdfBusy = false;
			}
		},
		startAction(item) {
			const msg = this.$createElement;
			const msgNode = msg('div', {
				domProps: {
					innerHTML: '<p>Pada masa Stock Opname, semua control card tidak dapat dipindahkan ke area lain. Apakah anda yakin untuk memulai Stock Opname ?</p>'
				}
			});
			this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Confirmation',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'danger',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(async value => {
				if (value) {
					let this_ = this;
					this_.$http.post('StockOpnamePlan/stockOpname/' + item.id)
					.then(async function(response){
						this_.getStockOpnamePlans();
					})
					.catch(function(error){
						this_.$store.dispatch('addErrorMessageGlobal', error);
						throw error;
					});
				}
			})
			.catch(err => {})
		},
		finishAction(item) {
			this.selectedStockOpnamePlanId = item.id;
			this.isShowPopupBeritaAcara = true;
		},
		getStockOpnamePlans : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			StockOpnamePlan.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.stockOpnamePlans = result.data
					this.stockOpnamePlansPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getStockOpnamePlansWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			StockOpnamePlan.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.stockOpnamePlans = result.data
					this.stockOpnamePlansPaging = result
				}
			})
			.catch(error => {});
		},
		getStockOpnameStatuss : async function(input) {
			let filter = new StockOpnameStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			await StockOpnameStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.stockOpnameStatuss = result.data
				}
			})
			.catch(error => {});
		},
		getStockOpnameStatus : async function(input) {
			let filter = new StockOpnameStatusFilter();
			filter.code = "NOT_ACTIVE";
			if (input != undefined) {
				filter.name = input;
			}
			StockOpnameStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.stockOpnameStatusNotActive = result.data[0]
				}
			})
			.catch(error => {});
		},
		resetFilter() {
			this.filter = new StockOpnamePlanFilter();
			this.getStockOpnamePlans();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetPopupBeritaAcara() {
			this.isShowPopupBeritaAcara = false;
			this.selectedStockOpnamePlanId = '';
			this.getStockOpnamePlans();
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getStockOpnamePlans();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				StockOpnamePlan.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
				this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			StockOpnamePlan.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			StockOpnamePlan.downloadData(this, this.filter, this.sortingBy)
			.then(result => {
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			})
			.catch(error => { 
				this.isDownloadDataBusy = false; 
			})
		},

		deleteData(id) {
			StockOpnamePlan.deleteData(this, id).then(result => {
				if (result)
				{
					this.getStockOpnamePlans();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				StockOpnamePlan.deleteMultipleData(this).then(result => {
					this.getStockOpnamePlans();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tableStockOpnamePlanParent = document.getElementById('table-list-stockopnameplan').parentNode;
			tableStockOpnamePlanParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tableStockOpnamePlanParent.scrollWidth - tableStockOpnamePlanParent.offsetWidth) == Math.ceil(tableStockOpnamePlanParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tableStockOpnamePlanParent = document.getElementById('table-list-stockopnameplan').parentNode;
			tableStockOpnamePlanParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tableStockOpnamePlanParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new StockOpnamePlanFilter();
		// this.getStockOpnameStatuss()
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Stock Opname Plan"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.getStockOpnameStatus();
		this.getStockOpnameStatuss();
		this.$nextTick(() => {
			this.getStockOpnamePlans();
			window.addEventListener('resize', this.onResize);
		});
	},	watch: {
		sortBy: {
			handler: function() {
				this.getStockOpnamePlans();
			}
		},
		sortDesc: {
			handler: function() {
				this.getStockOpnamePlans();
			}
		},
		currentPage: {
			handler: function() {
				this.getStockOpnamePlans();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getStockOpnamePlans();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				StockOpnamePlan.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "stockopnameplanindex") {
					this.getStockOpnamePlansWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "stock_opname_plan").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}
			
			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
